/* eslint max-len: ["error", { "code": 130, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Utils} from './Utils';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {apiTelomereAge, resetErrorTelomere} from '../actions/telomere';
import {resetErrorLogin} from '../actions/login';
import Snackbar from 'material-ui/Snackbar';
import {red500} from 'material-ui/styles/colors';
import {history} from '../store';
import CircularProgress from 'material-ui/CircularProgress';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {grey600, blue300, red700, white, indigo900, green900, green300} from 'material-ui/styles/colors';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import {Animated} from 'react-animated-css';

import '../css/TelomereTool.css';
Utils.init('Telomere');

export class TelomereTool extends Component {
    static propTypes = {
        login: PropTypes.object.isRequired,
        telomere: PropTypes.object.isRequired,
        locale: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        calcTelomere: PropTypes.func.isRequired,
        resetError: PropTypes.func.isRequired,
        resetLogin: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {age: 30, sex: 0, length: 8, open: false, message: ''};
    }

    handleCalcTelomere = (event) => {
        event.preventDefault();
        if (this.state.age >= 0 && this.state.length > 0) {
            this.props.calcTelomere(this.state.age, this.state.sex, this.state.length);
        } else {
            this.setState({
                open: true,
                message: this.props.locale.errorTelomere,
            });
        }
    };

    handleChangeLength = (event) => {
        if (event.target.value >= 0) {
            this.setState({length: event.target.value});
        } else {
            this.setState({
                open: true,
                message: this.props.locale.errorTelomereLength,
            });
        }
    };

    handleChangeAge = (event) => {
        if (event.target.value >= 0 && event.target.value < 150) {
            this.setState({age: event.target.value});
        } else {
            this.setState({
                open: true,
                message: this.props.locale.errorTelomereAge,
            });
        }
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        if (!this.props.login.logged) {
            history.push('/');
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.login.logged) {
            history.push('/');
        }

        if (nextProps.telomere.error && nextProps.telomere.errorCode === 403) {
            this.props.resetLogin();
            this.setState({
                open: true,
                message: this.props.locale.loginExpired,
            });
        }

        if (nextProps.telomere.error && nextProps.telomere.errorCode === 403) {
            this.props.resetError();
            this.setState({
                open: true,
                message: this.props.locale.notAllowed,
            });
        }

        if (nextProps.telomere.error && nextProps.telomere.errorCode === 500) {
            this.props.resetError();
            this.setState({
                open: true,
                message: this.props.locale.errcalcTelomere,
            });
        }
    }

    render() {
        let telomereProgress = <div/>;
        if (this.props.telomere.isFetching) {
            telomereProgress =
                <div className="circular-progress">
                    <CircularProgress/>
                </div>;
        }
      let standardDev = <div/>;
      if (this.props.telomere.devWarning) {
        standardDev =
          <Chip style={{margin: 4, marginBottom: 25}}
                backgroundColor={red700}
                labelColor={white}
          >
            {this.props.locale.lengthDeviationWarning}
          </Chip>;
      }
        let telomereCalculation = <div/>;
        if (this.props.telomere.calcOk) {
            telomereCalculation =
                <div>
                    <div id="algores">
                      <Card className='telomere-card'>
                        <CardHeader
                          title={<strong>{this.props.locale.baseData}</strong>}
                        />
                        <CardText>
                          <Chip style={{margin: 4, marginBottom: 25}}
                                backgroundColor={blue300}
                                labelColor={white}
                          >
                            <Avatar size={32} color={white} backgroundColor={indigo900}>
                              {this.props.telomere.ageMean.toFixed(1)}
                            </Avatar>
                            {this.props.locale.ageMean}
                          </Chip>
                          <Chip style={{margin: 4, marginBottom: 25}}
                                backgroundColor={blue300}
                                labelColor={white}
                          >
                            <Avatar size={32} color={white} backgroundColor={indigo900}>
                              {this.props.telomere.telomereMLLength.toFixed(1)}
                            </Avatar>
                            {this.props.locale.telomereMLLength}
                          </Chip>
                          <Chip style={{margin: 4, marginBottom: 25}}
                                backgroundColor={blue300}
                                labelColor={white}
                          >
                            <Avatar size={32} color={white} backgroundColor={indigo900}>
                              {this.props.telomere.lengthMean.toFixed(1)}
                            </Avatar>
                            {this.props.locale.lengthMean}
                          </Chip>
                        <Chip style={{margin: 4, marginBottom: 25}}
                              backgroundColor={blue300}
                              labelColor={white}
                        >
                          <Avatar size={32} color={white} backgroundColor={indigo900}>
                            {this.props.telomere.lengthDev.toFixed(1)}
                          </Avatar>
                          {this.props.locale.lengthDeviation}
                        </Chip>
                          {standardDev}
                        </CardText>
                      </Card>
                        <Card className='telomere-card'>
                            <CardHeader
                                title={<strong>{this.props.locale.algorithmG}</strong>}
                            />
                            <CardText>
                                <Chip style={{margin: 4, marginBottom: 25}}
                                      backgroundColor={blue300}
                                      labelColor={white}
                                >
                                    <Avatar size={32} color={white} backgroundColor={indigo900}>
                                        {this.props.telomere.algoG}
                                    </Avatar>
                                    {this.props.locale.bruteForceAlgo}
                                </Chip>
                            </CardText>
                        </Card>
                        <Card className='telomere-card'>
                            <CardHeader
                                title={<strong>{this.props.locale.telomereMLAge}</strong>}
                            />
                            <CardText>
                                <Chip style={{margin: 4, marginBottom: 25}}
                                      backgroundColor={blue300}
                                      labelColor={white}
                                >
                                    <Avatar size={32} color={white} backgroundColor={indigo900}>
                                        {this.props.telomere.telomereMLAge}
                                    </Avatar>
                                    {this.props.locale.telomereMLAge}
                                </Chip>
                                <Animated animationIn="tada" isVisible={true}>
                                    <Chip style={{margin: 4, marginBottom: 25}}
                                          backgroundColor={green300}
                                          labelColor={white}
                                    >
                                        <Avatar size={32} color={white} backgroundColor={green900}>
                                            {this.props.telomere.suggestedAge}
                                        </Avatar>
                                        {this.props.locale.suggestedAge}
                                    </Chip>
                                </Animated>
                            </CardText>
                        </Card>
                        <Card className='telomere-card'>
                            <CardHeader
                                title={<strong>{this.props.locale.algorithmLab}</strong>}
                            />
                            <CardText>
                                <Animated animationIn="none" isVisible={true}>
                                    <Chip style={{margin: 4, marginBottom: 25}}>
                                        <Avatar size={32}>{Math.round(this.props.telomere.labAge)}</Avatar>
                                        {this.props.locale.algorithmLab}
                                    </Chip>
                                </Animated>
                            </CardText>
                        </Card>
                    </div>
                    <img src={this.props.telomere.urlGraph}
                         className="telomere-image"
                         style={{marginTop: '30px', marginBottom: '30px'}}
                         alt="telomere-graph"/>
                </div>;
        }

        return (
            <div className="telomere-div">
                <form style={{margin: 'auto'}} autoFocus>
                    <h1 style={{textAlign: 'center'}}>{this.props.locale.tool}</h1>
                    <TextField className="input-el" style={{display: 'block'}}
                               hintText={this.props.locale.length}
                               floatingLabelText={this.props.locale.length}
                               floatingLabelStyle={{fontSize: '20px', color: grey600}}
                               floatingLabelFocusStyle={{fontSize: '20px', color: this.props.theme.primaryColor}}
                               type='number'
                               step="0.01" min="0.01" max="10"
                               onChange={this.handleChangeLength}
                               value={this.state.length}
                    />
                    <TextField className="input-el" style={{display: 'block'}}
                               hintText={this.props.locale.age}
                               floatingLabelText={this.props.locale.age}
                               floatingLabelStyle={{fontSize: '20px', color: grey600}}
                               floatingLabelFocusStyle={{fontSize: '20px', color: this.props.theme.primaryColor}}
                               type='number'
                               step="1" min="0" max="150"
                               onChange={this.handleChangeAge}
                               value={this.state.age}
                    />
                    <div className="input-el">
                        <RadioButtonGroup name="sex"
                                          valueSelected={this.state.sex}
                                          onChange={(event, value) => this.setState({sex: value})}
                        >
                            <RadioButton
                                value={0}
                                label={this.props.locale.male}
                                style={{display: 'inline-block', width: 'inherit', marginRight: '10px', marginTop: '10px'}}
                            />
                            <RadioButton
                                value={1}
                                label={this.props.locale.female}
                                style={{display: 'inline-block', width: 'inherit', marginRight: '10px', marginTop: '10px'}}
                            />
                        </RadioButtonGroup>
                    </div>
                    <RaisedButton style={{display: 'block', margin: '30px auto', width: '150px'}}
                                  label={this.props.locale.calculate}
                                  type="submit"
                                  onClick={this.handleCalcTelomere}
                    />
                    <div style={{margin: 'auto'}}/>
                    <Snackbar
                        open={this.state.open}
                        message={this.state.message}
                        autoHideDuration={4000}
                        onRequestClose={this.handleRequestClose}
                        bodyStyle={{backgroundColor: red500}}
                    />
                    {telomereProgress}
                    {telomereCalculation}
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    login: state.login,
    telomere: state.telomere,
    locale: state.locale.locale,
    theme: state.theme,
});

const mapDispatchToProps = {
    calcTelomere: apiTelomereAge,
    resetError: resetErrorTelomere,
    resetLogin: resetErrorLogin,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TelomereTool);



// WEBPACK FOOTER //
// ./src/components/TelomereTool.js